import React from 'react';
import { DatePicker, Form } from '@common/components';
import { datetime, type DatetimeType } from '@common/services/datetime';
import { WorksListItemExpirationType } from '@onboarding/services';

type Props = {
  expirationType: WorksListItemExpirationType;
};

export const disabledCompletedOn = (day: DatetimeType) =>
  day.isAfter(datetime());

export const disabledExpiresOn = (day: DatetimeType) =>
  day.isBefore(datetime());

export function checkDocumentExpiration(
  _: unknown,
  selectedEndDate: DatetimeType
) {
  if (!selectedEndDate) {
    return Promise.resolve();
  }

  const today = datetime().startOf('day');

  return selectedEndDate.isBefore(today)
    ? Promise.reject('The document is expired')
    : Promise.resolve();
}

export function ComplianceItemInputExpirationDate({ expirationType }: Props) {
  return (
    <>
      {expirationType === 'COMPLETION_DATE' && (
        <Form.Item
          label="Completed On"
          name="completedOn"
          key="completedOn"
          rules={[
            { required: true, message: 'Please enter a completion date' },
          ]}
        >
          <DatePicker
            placeholder="mm/dd/yyyy"
            format="MM/DD/YYYY"
            size="large"
            className="sra-large-input"
            style={{ width: '100%' }}
            disabledDate={disabledCompletedOn}
          />
        </Form.Item>
      )}

      {expirationType === 'EXPIRATION_DATE' && (
        <Form.Item
          label="Expires On"
          name="expiresOn"
          key="expiresOn"
          rules={[
            { required: true, message: 'Please enter an expiration date' },
            { validator: checkDocumentExpiration },
          ]}
        >
          <DatePicker
            placeholder="mm/dd/yyyy"
            format="MM/DD/YYYY"
            size="large"
            className="sra-large-input"
            style={{ width: '100%' }}
            disabledDate={disabledExpiresOn}
          />
        </Form.Item>
      )}
    </>
  );
}
